import { mutate } from "swr";
import { apiClient } from "@nkr/utils/api/api-client";

export interface EpletAllele {
    id: number;
    hlaString: string;
    isLinked: boolean;
    isMatchedOnGene: boolean;
    isMatchedOnResidue: boolean;
}

export interface EpletSummary {
    id: number;
    hlaGeneGroupId: number;
    hlaGeneGroup: string;
    name: string;
    residue: string;
    hasOnlyValidatedAlleles: boolean;
    linkedCount: number;
    missingCount: number;
    invalidCount: number;
}

export interface EpletDetail extends EpletSummary {
    alleles: EpletAllele[];
}

export interface EpletLinkRequest {
    id: number;
    alleleIds: number[];
}

const summaryRoute      = `${__API__}/admin/hla/eplet`;
const epletRoute        = (id: number): string => `${summaryRoute}/${id}`;
const ALL_GENE_GROUPS   = -1;

const isSummaryKey = (key: unknown): boolean => {
    return typeof key === "string" && (key === summaryRoute || key.startsWith(`${summaryRoute}?`));
}

/**
 * had problem with list not refreshing after create/delete...so provide method for invalidating SWR cache.
 */
export const invalidateEpletSummaries = (): Promise<unknown> =>
    mutate(isSummaryKey, undefined, { revalidate: true });

export const epletValidationApi = {
    useGetSummary   : (hlaGeneGroupId: number | null = null) => apiClient.useGetMany<EpletSummary, number>(
        hlaGeneGroupId === null ? ALL_GENE_GROUPS : hlaGeneGroupId,
        group => (group === ALL_GENE_GROUPS ? summaryRoute : `${summaryRoute}?group=${group}`)
    ),

    useGetById      : (id: number | null) => apiClient.useGetOne<EpletDetail, number>(id, epletId => epletRoute(epletId)),

    useCreateLinks  : () => apiClient.usePutAction<EpletDetail, EpletLinkRequest>(request => epletRoute(request.id)),

    useDeleteLinks  : () => apiClient.useDelete<EpletLinkRequest>(request => epletRoute(request.id)),
};
